import { LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { Module } from '../Module';
import { ExternalAuthService } from '../services/ExternalAuthService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import {getAuthenticationServiceInstance} from '../../authentication/services/AuthenticationService';

export interface ISignedOutScope extends ng.IScope {
  tryAgainLink: string;
}

export class SignedOutCtrl {

  public static $inject = [
    '$scope',
    'ExternalAuthService'
  ];

  constructor(
    $scope: ISignedOutScope,
    externalAuthService: ExternalAuthService
  ) {
    $scope.tryAgainLink = getAuthenticationServiceInstance().isAuthenticationExternal() && !(ServerSettingsUnauthenticated.isSiteSamlEnabled() && ServerSettingsUnauthenticated.isServerDomainFamilyLocal()) ?
      externalAuthService.getLoginUrl({}) :
      LoginUrlsWrapper.getInstance().signinUrl({});
  }

}

Module.instance().controller('SignedOutCtrl', SignedOutCtrl);
